import { type KickPlateCountersinkHoles } from 'metalworks-domain'

import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { GenericDistancePropertyContainerItem } from './GenericDistancePropertyPage'
import { KickPlateHolesCountPropertyPage } from './KickPlateHolesCountPropertyPage'

interface Props {
  id: KickPlateCountersinkHoles['id']
}

export const KickPlateCountersinkHolePropertyPage = (props: Props) => {
  const { id } = props

  return (
    <PropertyContainer.Group spacing="large">
      <GenericDistancePropertyContainerItem id={id} />
      <KickPlateHolesCountPropertyPage id={id} />
    </PropertyContainer.Group>
  )
}
